import { useContext } from 'react';
import { DSIconSizes } from '@elliemae/ds-icon';
import { BUTTON_TYPES } from '@elliemae/ds-button-v2';
import { ChevronRight, ChevronLeft } from '@elliemae/ds-icons';
import { useOwnerProps } from '@elliemae/ds-props-helpers';
import {
  StyledCarouselBtnLeft,
  StyledCarouselBtnRight,
  StyledCarouselButtonWrapper,
  StyledCarouselWrapper,
  StyledChildrenWrap,
} from './styles.js';
import { useCarousel } from './useCarousel.js';
import { DSTabsContext } from '../../DSTabsCTX.js';
import { TABS_DATA_TESTID } from '../../constants/index.js';

interface CarouselPropsT {
  children: React.ReactNode;
}

export const Carousel = ({ children }: CarouselPropsT): JSX.Element => {
  const { showChevrons, leftButtonOnClick, rightButtonOnClick, handleOnClick, handleOnScroll } = useCarousel();

  const {
    carouselOnlyListRef,
    props,
    props: { type },
  } = useContext(DSTabsContext);

  const { getOwnerProps } = useOwnerProps(props);

  return (
    <StyledCarouselWrapper>
      {showChevrons.left && (
        <StyledCarouselButtonWrapper tabType={type}>
          <StyledCarouselBtnLeft
            size="s"
            onClick={leftButtonOnClick}
            tabIndex={-1}
            data-testid={TABS_DATA_TESTID.CAROUSEL_BUTTON_LEFT}
            buttonType={BUTTON_TYPES.ICON}
            aria-label="Scroll Left"
            getOwnerProps={getOwnerProps}
          >
            <ChevronLeft size={DSIconSizes.S} />
          </StyledCarouselBtnLeft>
        </StyledCarouselButtonWrapper>
      )}
      {showChevrons.right && (
        <StyledCarouselButtonWrapper tabType={type} right={showChevrons.right}>
          <StyledCarouselBtnRight
            size="s"
            onClick={rightButtonOnClick}
            tabIndex={-1}
            data-testid={TABS_DATA_TESTID.CAROUSEL_BUTTON_RIGHT}
            buttonType={BUTTON_TYPES.ICON}
            aria-label="Scroll Right"
            getOwnerProps={getOwnerProps}
          >
            <ChevronRight size={DSIconSizes.S} />
          </StyledCarouselBtnRight>
        </StyledCarouselButtonWrapper>
      )}
      <StyledChildrenWrap
        role="tablist"
        innerRef={carouselOnlyListRef}
        onClick={handleOnClick}
        onScroll={handleOnScroll}
      >
        {children}
      </StyledChildrenWrap>
    </StyledCarouselWrapper>
  );
};
